import bindAll from 'lodash.bindall';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import VM from '@peiyou/scratch-vm';

// import xhr from 'xhr';
import axios from '../lib/services';
import log from '../lib/log';
import storage from '../lib/storage';
import dataURItoBlob from '../lib/data-uri-to-blob';
import {
    showAlertWithTimeout,
    showStandardAlert
} from '../reducers/alerts';
import {setAutoSaveTimeoutId} from '../reducers/timeout';
import {setProjectUnchanged} from '../reducers/project-changed';
import {setSubmitStatus} from '../reducers/isSubmitStatus';
import {
    LoadingStates,
    autoUpdateProject,
    createProject,
    doneCreatingProject,
    doneUpdatingProject,
    donePublishingProject,
    getIsAnyCreatingNewState,
    getIsCreatingCopy,
    getIsCreatingNew,
    getIsManualUpdating,
    getIsRemixing,
    getIsShowingWithId,
    getIsShowingWithoutId,
    getIsAutoUpdating,
    getIsUpdating,
    getIsPublish,
    projectError,
    setOriginalId,
    setProjectId,
    setProjectThumbnailpath
} from '../reducers/project-state';
import swal from './swal';
import {messyParams} from './messy-params';
import {
    reportResult,
    changeUrl
    // scratchSaved,
    // scratchCheckpointSaved
} from './services/postmessage';
import {
    getOssSign,
    upload
} from './services/scratch-ser';
import batchToRun from './batchToRun';
import errorMsg from '../lib/errorMsg';
import {
    base64toFile,
    unit8ArryToFile
} from '../lib/transfer-format';
/**
 * Higher Order Component to provide behavior for saving projects.
 * @param {React.Component} WrappedComponent the component to add project saving functionality to
 * @returns {React.Component} WrappedComponent with project saving functionality added
 *
 * <ProjectSaverHOC>
 *     <WrappedComponent />
 * </ProjectSaverHOC>
 */
const ProjectSaverHOC = function (WrappedComponent) {
    class ProjectSaverComponent extends React.Component {
        constructor (props) {
            super(props);
            bindAll(this, [
                'leavePageConfirm',
                'tryToAutoSave'
                // 'receiveMessage'
            ]);
        }
        componentWillMount () {
            // if (typeof window === 'object') {
            //     // Note: it might be better to use a listener instead of assigning onbeforeunload;
            //     // but then it'd be hard to turn this listening off in our tests
            //     window.onbeforeunload = e => this.leavePageConfirm(e);
            // }
        }

        componentDidMount () {
            // window.addEventListener('message', this.receiveMessage, false);
        }

        componentDidUpdate (prevProps) {
            if (this.props.projectChanged && !prevProps.projectChanged) {
                if (this.props.canSaveProj) {
                    this.scheduleAutoSave();
                }
            }
            if (this.props.isUpdating && !prevProps.isUpdating) {
                // 自动保存的时候不显示保存后的提示
                this.updateProjectToStorage(!this.props.isAutoUpdating);
            }
            if (this.props.isCreatingNew && !prevProps.isCreatingNew) {
                this.createNewProjectToStorage();
            }
            if (this.props.isCreatingCopy && !prevProps.isCreatingCopy) {
                this.createCopyToStorage();
            }
            if (this.props.isRemixing && !prevProps.isRemixing) {
                this.props.onRemixing(true);
                this.createRemixToStorage();
            } else if (!this.props.isRemixing && prevProps.isRemixing) {
                this.props.onRemixing(false);
            }

            // see if we should "create" the current project on the server
            //
            // don't try to create or save immediately after trying to create
            if (prevProps.isCreatingNew) return;
            // if we're newly able to create this project, create it!
            if (this.isShowingCreatable(this.props) && !this.isShowingCreatable(prevProps)) {
                this.props.onCreateProject();
            }

            // see if we should save/update the current project on the server
            //
            // don't try to save immediately after trying to save
            if (prevProps.isUpdating) return;
            // if we're newly able to save this project, save it!
            const becameAbleToSave = this.props.canSave && !prevProps.canSave;
            const becameShared = this.props.isShared && !prevProps.isShared;
            if (this.props.isShowingSaveable && (becameAbleToSave || becameShared)) {
                this.props.onAutoUpdateProject();
            }
        }
        componentWillUnmount () {
            this.clearAutoSaveTimeout();
            // window.removeEventListener('message', this.receiveMessage, false);
            // Cant unset the beforeunload because it might no longer belong to this component
            // i.e. if another of this component has been mounted before this one gets unmounted
            // which happens when going from project to editor view.
            // window.onbeforeunload = undefined; // eslint-disable-line no-undefined
        }

        handleReceiveSaveProj (showMessage = false) {
            this.updateProjectToStorage(showMessage);
        }
        leavePageConfirm (e) {
            if (this.props.projectChanged) {
                // both methods of returning a value may be necessary for browser compatibility
                (e || window.event).returnValue = true;
                return true;
            }
            return; // Returning undefined prevents the prompt from coming up
        }
        clearAutoSaveTimeout () {
            if (this.props.autoSaveTimeoutId !== null) {
                clearTimeout(this.props.autoSaveTimeoutId);
                this.props.setAutoSaveTimeoutId(null);
            }
        }
        scheduleAutoSave () {
            if (this.props.isShowingSaveable && this.props.autoSaveTimeoutId === null) {
                const timeoutId = setTimeout(this.tryToAutoSave,
                    this.props.autoSaveIntervalSecs * 1000);
                this.props.setAutoSaveTimeoutId(timeoutId);
            }
        }
        tryToAutoSave () {
            if (this.props.projectChanged && this.props.isShowingSaveable) {
                this.props.onAutoUpdateProject();
            }
        }
        isShowingCreatable (props) {
            return props.canCreateNew && props.isShowingWithoutId;
        }
        // PNGJU Uint8Array转成base64
        uint8ArrayToBase64 (contenType, bytes) {
            let binary = '';
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[ i ]);
            }
            
            return `data:${contenType};base64,${window.btoa(binary)}`;
        }
    
        updateProjectToStorage (showSuccAlert = true) {
            this.props.onShowSavingAlert();
            return this.storeProject(this.props.reduxProjectId)
                .then(response => {
                    // there's an http response object available here, but we don't need to examine
                    // it, because there are no values contained in it that we care about
                    this.props.onUpdatedProject(this.props.loadingState);
                    this.props.onShowSaveSuccessAlert();
                    if (showSuccAlert) {
                        swal.succ(errorMsg.SAVE_SUCCESS);
                    }
                    reportResult();
                    return response;
                })
                .catch(err => {
                    // Always show the savingError alert because it gives the
                    // user the chance to download or retry the save manually.
                    this.props.onShowAlert('savingError');
                    this.props.onProjectError(err);
                    if (showSuccAlert) {
                        swal.swalAgent(err, errorMsg.SAVE_ERROR);
                    }
                    return Promise.reject(err);
                });
        }

        changeHashFn (id) {
            // eslint-disable-next-line no-return-assign
            setTimeout(() => {
                const cId = `#${id}`;
                if (location.hash !== cId) {
                    location.hash = cId;
                    // const regExt = /projectId=(.*)[(#|&)]/;
                    const href = window.location.href;
                    console.log("🚀 ~ file: project-saver-hoc.jsx:218 ~ ProjectSaverComponent ~ setTimeout ~ href:", href)
                    // const regArray = href.match(regExt);
                    // let newHref = href;
                    // if (regArray && regArray[1]) {
                    //     newHref = href.replace(
                    //       new RegExp('projectId=' + regArray[1], 'g'),
                    //       'projectId=' + id
                    //     );
                    // }
                    // window.history.replaceState({}, '', newHref);
                    // window.location.href = newHref;
                    console.log(
                      '🚀 ~ file: project-saver-hoc.jsx:229 ~ ProjectSaverComponent ~ setTimeout ~ window:',
                      window.parent
                    );
                    changeUrl(id);
                    // if (window.parent !== window) {
                    //     window.parent.history.replaceState({}, '', newHref);
                    //     // window.parent.location.reload()
                    //     const doc = window.parent.document;
                    //     const iframe = doc.getElementById('scratchEditor');
                    //     iframe.src = newHref;
                    // }
                }
            });
        }

        createNewProjectToStorage () {
            return this.storeProject(null)
                .then(response => {
                    this.props.onCreatedProject(response.id.toString(), this.props.loadingState);
                })
                .catch(err => {
                    this.props.onShowAlert('creatingError');
                    this.props.onProjectError(err);
                });
        }
        createCopyToStorage () {
            this.props.onShowCreatingCopyAlert();
            return this.storeProject(null, {
                original_id: this.props.reduxProjectId,
                is_copy: 1,
                title: this.props.reduxProjectTitle
            })
                .then(response => {
                    this.props.onCreatedProject(response.id.toString(), this.props.loadingState);
                    this.props.onShowCopySuccessAlert();
                })
                .catch(err => {
                    this.props.onShowAlert('creatingError');
                    this.props.onProjectError(err);
                });
        }
        createRemixToStorage () {
            this.props.onShowCreatingRemixAlert();
            return this.storeProject(null, {
                original_id: this.props.reduxProjectId,
                is_remix: 1,
                title: this.props.reduxProjectTitle
            })
                .then(response => {
                    this.props.onCreatedProject(response.id.toString(), this.props.loadingState);
                    this.props.onShowRemixSuccessAlert();
                })
                .catch(err => {
                    this.props.onShowAlert('creatingError');
                    this.props.onProjectError(err);
                });
        }

        /**
         * storeProject:
         * @param  {number|string|undefined} projectId - defined value will PUT/update; undefined/null will POST/create
         * @return {Promise} - resolves with json object containing project's existing or new id
         * @param {?object} requestParams - object of params to add to request body
         */
        storeProject (projectId) {

            this.clearAutoSaveTimeout();
            // Serialize VM state now before embarking on
            // the asynchronous journey of storing assets to
            // the server. This ensures that assets don't update
            // while in the process of saving a project (e.g. the
            // serialized project refers to a newer asset than what
            // we just finished saving).

            const savedVMState = this.props.vm.toJSON();
            if (!this.projetIsComplete(JSON.parse(savedVMState))) {
                return Promise.reject('项目保存遇到问题了，再试一次吧');
            }

            // 上传资源
            return this.uploadResources()
                // 上传缩略图
                .then(() => this.uploadThumbnail(projectId))
                // 生成项目文件
                .then(response => this.prepareProj(response, savedVMState, projectId))
                // 保存项目
                .then(params => axios.post(storage.getProjectCreateConfig(), params))
                // 保存成功之后
                .then(response => this.afterSaved(response))
                .catch(error => {
                    log.error(error);
                    return Promise.reject(error);
                });
        }

        uploadResources () {
            // 计算需要上传的资源列表
            const dirtyAssets = this.props.vm.assets
                .filter(asset => !asset.clean);
            // 生成请求 oss 授权的数据
            const dirtyAssetsConfig = dirtyAssets.map(item => ({
                type: 2,
                fileName: `${item.assetId}.${item.dataFormat}`
            }));

            if (dirtyAssetsConfig.length <= 0) {
                return Promise.resolve();
            }

            // 获取 oss 授权，生成上传 oss 函数数组
            return getOssSign({params: dirtyAssetsConfig})
                .then(res => dirtyAssets.map((item, index) => () => upload(
                    unit8ArryToFile(
                        item.data,
                        `${item.assetId}.${item.dataFormat}`,
                        item.assetType && item.assetType.contentType
                    ),
                    res.data.data[index].sign
                // 上传完成之后将 clean 标记为 true
                ).then(() => {
                    item.clean = true;
                })))
                // 开始批量上传 oss
                .then(res => batchToRun(res, 6));
        }

        uploadThumbnail (id) {
            let signRes = null;
            // 请求 oss
            return getOssSign({
                params: [{
                    type: 1,
                    fileName: `${id}.png`,
                    id
                }]
            })
                // 计算缩略图及组织上传数据
                .then(response => new Promise(resolve => {
                    const {sign} = response.data.data[0];
                    signRes = sign;
                    this.props.vm.renderer.requestSnapshot(dataURI => {
                        resolve([
                            base64toFile(dataURI, 'png'),
                            response.data.data[0].sign
                        ]);
                    });
                }))
                // 上传缩略图
                .then(response => upload(...response))
                // resolve 缩略图授信借口的返回内容
                .then(() => ({...signRes}));
        }

        prepareProj (res, vmstate, projId) {
            const {dir} = res;
            const title = this.props.projectTitle ? this.props.projectTitle : 'scratch新作品';
            // 保存项目资源
            const params = {
                description: '',
                id: projId,
                name: title,
                original_id: 0,
                thumbnail_path: dir,
                version: `3.0`,
                xml: vmstate
            };
            if (this.props.saveData !== null) {
                this.props.setOriginalId(this.props.saveData.original_id)
                Object.assign(params, {
                    description: this.props.saveData.description,
                    name: this.props.projectTitle ? this.props.projectTitle : this.props.saveData.name,
                    original_id: this.props.saveData.original_id,
                    product_id: this.props.saveData.product_id
                });
            }
            return {
                ...params,
                category: messyParams.category
            };
        }

        afterSaved (res) {
            const {id, name, thumbnail} = res.data.data;
            this.props.setProjectThumbnailpath(thumbnail);
            this.props.vm.renderer.requestSnapshot(() => {
                // const savedParams = {
                //     id,
                //     name,
                //     thumbnail: dataURI
                // };
                this.changeHashFn(id);
                this.props.setProjectId(id);
                this.props.onSetProjectUnchanged();

                // 后台录题用
                localStorage.codeMonkeyId = id;
                localStorage.SCRATCH_PRACTICE_NAME = name;

                // if (messyParams.target !== 'checkpoint') {
                //     scratchSaved(savedParams);
                // } else if (messyParams.target === 'checkpoint') {
                //     scratchCheckpointSaved(savedParams);
                // }
                // 储存缩略图逻辑
                if (id && this.props.onUpdateProjectThumbnail) {
                    this.storeProjectThumbnail(id);
                }
            });

            return res;
        }

        /**
         * Store a snapshot of the project once it has been saved/created.
         * Needs to happen _after_ save because the project must have an ID.
         * @param {!string} projectId - id of the project, must be defined.
         */
        storeProjectThumbnail (projectId) {
            // debugger
            try {
                this.props.vm.postIOData('video', {forceTransparentPreview: true});
                this.props.vm.renderer.requestSnapshot(dataURI => {
                    this.props.vm.postIOData('video', {forceTransparentPreview: false});
                    this.props.onUpdateProjectThumbnail(
                        projectId, dataURItoBlob(dataURI));
                });
                this.props.vm.renderer.draw();
            } catch (e) {
                log.error('Project thumbnail save error', e);
                // This is intentionally fire/forget because a failure
                // to save the thumbnail is not vitally important to the user.
            }
        }

        projetIsComplete (project) {
            return (
                project.targets &&
                (project.targets.length > 0)
            );
        }

        render () {
            const {
                /* eslint-disable no-unused-vars */
                saveData,
                submitStatus,
                autoSaveTimeoutId,
                autoSaveIntervalSecs,
                canSaveProj,
                isCreatingCopy,
                isCreatingNew,
                projectChanged,
                isAnyCreatingNewState,
                isManualUpdating,
                isRemixing,
                isShowingSaveable,
                isShowingWithId,
                isShowingWithoutId,
                isAutoUpdating,
                isUpdating,
                isPublish,
                loadingState,
                onAutoUpdateProject,
                onCreatedProject,
                onCreateProject,
                // onGetProjectdata,
                onProjectError,
                onPublishedProject,
                onRemixing,
                onSetProjectUnchanged,
                onShowAlert,
                onShowCopySuccessAlert,
                onShowRemixSuccessAlert,
                onShowCreatingCopyAlert,
                onShowCreatingRemixAlert,
                onShowSaveSuccessAlert,
                onShowSavingAlert,
                onUpdatedProject,
                onUpdateProjectThumbnail,
                reduxProjectId,
                reduxProjectTitle,
                setOriginalId,
                setSubmitStatus: setSubmitStatusProp,
                setAutoSaveTimeoutId: setAutoSaveTimeoutIdProp,
                setProjectThumbnailpath: setProjectThumbnailpathProp,
                setProjectId,
                /* eslint-enable no-unused-vars */
                ...componentProps
            } = this.props;
            return (
                <WrappedComponent
                    isCreating={isAnyCreatingNewState}
                    {...componentProps}
                />
            );
        }
    }

    ProjectSaverComponent.propTypes = {
        autoSaveTimeoutId: PropTypes.number,
        canCreateNew: PropTypes.bool,
        canSave: PropTypes.bool,
        isAnyCreatingNewState: PropTypes.bool,
        isAutoUpdating: PropTypes.bool,
        isCreatingCopy: PropTypes.bool,
        isCreatingNew: PropTypes.bool,
        isManualUpdating: PropTypes.bool,
        isRemixing: PropTypes.bool,
        isShared: PropTypes.bool,
        isShowingSaveable: PropTypes.bool,
        isShowingWithId: PropTypes.bool,
        isShowingWithoutId: PropTypes.bool,
        isUpdating: PropTypes.bool,
        loadingState: PropTypes.oneOf(LoadingStates),
        onAutoUpdateProject: PropTypes.func,
        onCreateProject: PropTypes.func,
        onCreatedProject: PropTypes.func,
        onProjectError: PropTypes.func,
        onPublishedProject: PropTypes.func,
        onRemixing: PropTypes.func,
        onShowAlert: PropTypes.func,
        onShowCopySuccessAlert: PropTypes.func,
        onShowCreatingCopyAlert: PropTypes.func,
        onShowCreatingRemixAlert: PropTypes.func,
        onShowRemixSuccessAlert: PropTypes.func,
        onShowSaveSuccessAlert: PropTypes.func,
        onShowSavingAlert: PropTypes.func,
       
        onUpdateProjectThumbnail: PropTypes.func,
        onUpdatedProject: PropTypes.func,
        projectChanged: PropTypes.bool,
        reduxProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        reduxProjectTitle: PropTypes.string,
        setSubmitStatus: PropTypes.func,
        // saveData: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        vm: PropTypes.instanceOf(VM).isRequired
    };
    ProjectSaverComponent.defaultProps = {
        autoSaveIntervalSecs: 60, // 60秒保存一次（仅在代码又变动的情况）
        onRemixing: () => {}
    };
    const mapStateToProps = state => {
        // const saveData=state.scratchGui.projectChanged.projectData;
        const loadingState = state.scratchGui.projectState.loadingState;
        const isShowingWithId = getIsShowingWithId(loadingState);
        return {
            autoSaveTimeoutId: state.scratchGui.timeout.autoSaveTimeoutId,
            canSaveProj: state.scratchGui.searchArgs.canSaveProj,
            isAnyCreatingNewState: getIsAnyCreatingNewState(loadingState),
            isCreatingCopy: getIsCreatingCopy(loadingState),
            saveData: state.scratchGui.getOriginData.projectDatafromNet,
            submitStatus: state.scratchGui.isSubmitStatus.submitStatus,
            isAutoUpdating: getIsAutoUpdating(loadingState),
            isCreatingNew: getIsCreatingNew(loadingState),
            isRemixing: getIsRemixing(loadingState),
            // isShowingSaveable: ownProps.canSave && isShowingWithId,
            isShowingSaveable: isShowingWithId,
            isShowingWithoutId: getIsShowingWithoutId(loadingState),
            isUpdating: getIsUpdating(loadingState),
            isPublish: getIsPublish(loadingState),
            isManualUpdating: getIsManualUpdating(loadingState),
            loadingState: loadingState,
            projectChanged: state.scratchGui.projectChanged,
            reduxProjectId: state.scratchGui.projectState.projectId,
            reduxProjectTitle: state.scratchGui.projectTitle,
            vm: state.scratchGui.vm
        };
    };
    const mapDispatchToProps = dispatch => ({
        onAutoUpdateProject: () => dispatch(autoUpdateProject()),
        onCreatedProject: (projectId, loadingState) => dispatch(doneCreatingProject(projectId, loadingState)),
        onCreateProject: () => dispatch(createProject()),
        onProjectError: error => dispatch(projectError(error)),
        onSetProjectUnchanged: () => dispatch(setProjectUnchanged()),
        // onGetProjectdata: () => dispatch(getProjectdata()),
        onShowAlert: alertType => dispatch(showStandardAlert(alertType)),
        onShowCopySuccessAlert: () => showAlertWithTimeout(dispatch, 'createCopySuccess'),
        onShowRemixSuccessAlert: () => showAlertWithTimeout(dispatch, 'createRemixSuccess'),
        onShowCreatingCopyAlert: () => showAlertWithTimeout(dispatch, 'creatingCopy'),
        onShowCreatingRemixAlert: () => showAlertWithTimeout(dispatch, 'creatingRemix'),
        onShowSaveSuccessAlert: () => showAlertWithTimeout(dispatch, 'saveSuccess'),
        onShowSavingAlert: () => showAlertWithTimeout(dispatch, 'saving'),
        onUpdatedProject: (projectId, loadingState) => dispatch(doneUpdatingProject(projectId, loadingState)),
        onPublishedProject: () => dispatch(donePublishingProject()),
        setAutoSaveTimeoutId: id => dispatch(setAutoSaveTimeoutId(id)),
        setSubmitStatus: submitStatus => dispatch(setSubmitStatus(submitStatus)),
        setProjectThumbnailpath: path => dispatch(setProjectThumbnailpath(path)),
        setOriginalId: id => dispatch(setOriginalId(id)),
        setProjectId: id => dispatch(setProjectId(id))
    });
    // Allow incoming props to override redux-provided props. Used to mock in tests.
    const mergeProps = (stateProps, dispatchProps, ownProps) => Object.assign(
        {}, stateProps, dispatchProps, ownProps
    );
    return connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(ProjectSaverComponent);
};

export {
    ProjectSaverHOC as default
};
